import { ReactNode } from 'react'

export type SettingsAiAgentLayoutShadcnComponentProps = {
  children: ReactNode
}

export function SettingsAiAgentLayoutShadcnComponent({ children }: SettingsAiAgentLayoutShadcnComponentProps) {
  return <>{children}</>
}
